//See EnvConfigurationService for dynamic configuration
export const environment = {
  production: true,
  version: '7.0.1',
  apiUrl: 'https://machinetk.michelin.com',
  keyToken: 'currentUser',
  keyPermissions: 'permissions',
  keySelectedMine: 'selectedMine'
};
